import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import CheckInHeader from '../../components/check-in/CheckInHeader';
import { splashCloudAsset } from '../../data/check-in';

export default function CheckInSplashPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const fromTransition = (location.state as { fromTransition?: boolean })?.fromTransition === true;

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/check-in/weather', { replace: true });
    }, 1000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        background: 'linear-gradient(to bottom, #00A7C8 21.1%, #FFFFFF 92.1%)',
      }}
    >
      <CheckInHeader />

      <motion.div
        className="flex-1 flex flex-col items-center justify-center px-6 w-full max-w-[430px] mx-auto"
        initial={fromTransition ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <img
          src={splashCloudAsset}
          alt="Happy cloud"
          className="w-[260px] h-[260px] max-w-full"
        />
        <p
          className="text-center text-[#1B2831] font-semibold text-2xl md:text-[26px] lg:text-[28px] mt-6 max-w-[320px]"
          style={{ fontFamily: 'DM Sans', letterSpacing: '-0.96px' }}
        >
          How are you feeling today?
        </p>
      </motion.div>
    </div>
  );
}
